<template>
  <div>
    <!--<app-filter :total="total" label="Rapport(s) de Flux" :bigTotal="null"
                helper="62IXM27RgkmgACCKEGc6qU"
                :actions="actionButtons" :loading="loading">
      <div slot="filter-button"></div>
    </app-filter>-->
    <sticky class="page-header sticky-page-header page-header--new"
            :bigTotal="null"
            :back-button="true"
            :loading="loading"
            :total="total"
            :label="'Rapport(s) de Flux'">

      <div class="column is-paddingless is-border-left" slot="right-content">
        <a href="#"
          @click="removeAllFlux()" 
          :to="{name: 'UserCreate'}" class="page-header-btn is-small">
          <span class="icon"><i class="fas fa-trash"></i></span>
          <span>Tout supprimer</span>
        </a>
      </div>
      <div class="column is-paddingless is-border-left" slot="right-content">
        <a href="#"
          @click="loadItems()" 
          :to="{name: 'UserCreate'}" class="page-header-btn is-small is-square">
          <span class="icon"><i class="fas fa-sync"></i></span>
        </a>
      </div>
    </sticky>

    <div v-if="items && !loading" class="columns is-gapless is-padding-left-on-btn-actions is-padding-right-on-btn-actions">
      <div class="column is-8 is-border-right is-padding-top-small">
        <h2 class="is-size-4 is-padding-left is-padding-right">
          <strong>Les Flux</strong>
        </h2>
        <div class="column lignes-origines">
          <div v-for="(flux, idx) in filteredFlux" @click.prevent.stop="selectedFlux = flux" :key="idx"
               class="ligne-origine is-border-top is-border-left is-border-right is-margin-bottom">
            <div class="columns is-border-bottom is-vcentered has-bg-white">
              <div class="column">
                {{flux[0].promoteur_name}}
                <span class="tag is-info is-xsmall" v-if="countSuccess(flux[0])">{{countSuccess(flux[0])}} réussis</span>
                <span class="tag is-danger is-xsmall" v-if="countError(flux[0])">{{countError(flux[0])}} erreurs</span>
                <br>
                <span class="is-size-6 has-text-grey">{{ flux[0].created_on | prettyDate }} à {{ flux[0].created_on | prettyTime }}</span>
              </div>
              <div class="column is-narrow is-uppercase is-size-7 is-paddingless-left on-hover">
                <a @click.prevent.stop="selectedFlux = flux">Voir</a>
              </div>
              <div class="column is-narrow is-uppercase is-size-7 is-paddingless-left on-hover">
                <a @click.prevent.stop="deleteFlux(flux)">Supprimer</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="columns is-column column is-4 has-bg-white" v-if="selectedFlux && Object.keys(selectedFlux).length" style="overflow: auto; height: 85vh">
        <div class="column is-narrow is-paddingless is-tab-like is-border-bottom columns is-gapless is-vcentered">
          <div class="column is-narrow">
            <strong class="is-padding-left-small is-padding-right-small">Rapport {{selectedFlux[0].promoteur_name}}</strong>
          </div>
          <div class="column" style="min-height: 50px">
          </div>
        </div>

        <ul class="column is-paddingless liste-couts">
          <li v-for="(flux, idx) in selectedFlux" :key="idx">
            <flux-item :source="flux"></flux-item>
          </li>
        </ul>
      </div>
    </div>
    <div v-else v-show="!loading">
      <div class="columns">
        <div class="column">
          <h2 class="title is-3 has-text-weight-bold">Aucun flux disponible</h2>
          <a class="has-text-primary" @click="resetFilters" v-if="hasFilter"><span class="icon is-small"><i
            class="fal fa-undo-alt"></i></span> <span>Réinitialiser les filtres</span></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { GenericList, Sort, Filter, DefaultValues } from '../../mixins'
  import FluxItem from './FluxItem'

  export default {
    name: 'FluxList',
    mixins: [GenericList, Sort, Filter, DefaultValues],
    components: {FluxItem},
    filters: {
      truncate (value) {
        return value.length >= 50 ? value.substring(0, 50) + '...' : value
      }
    },
    data () {
      return {
        currentDropDownActive: null,
        actionButtons: [
          {
            linkClass: ['button', 'is-white'],
            icon: ['fa-trash'],
            action: () => {
              this.removeAllFlux()
            },
            text: 'Tout supprimer'
          },
          {
            linkClass: ['button', 'is-white'],
            icon: ['fa-sync'],
            action: () => {
              this.loadItems()
            }
          }
        ],
        service: this.$api.fluxService,
        loadDocuments: this.loadItems,
        selectedFlux: {}
      }
    },
    computed: {
      ...mapState(['currentUser']),
      filteredFlux () {
        let flux = {}
        this.items.map((el, idx) => {
          if (!Array.isArray(flux[el.promoteur])) flux[el.promoteur] = []
          flux[el.promoteur].push(el)
        })
        return flux
      }
    },
    methods: {
      countError (e) {
        return e.program_added_number_failed +
          e.program_updated_number_failed +
          e.program_deleted_number_failed +
          e.lot_added_number_failed +
          e.lot_updated_number_failed +
          e.lot_deleted_number_failed
      },
      countSuccess (e) {
        return e.program_added_number +
          e.program_updated_number +
          e.program_deleted_number +
          e.lot_added_number +
          e.lot_updated_number +
          e.lot_deleted_number
      },
      eventElipsis (reasons, len = 50) {
        let str = ''
        reasons.forEach((r, i) => {
          if (str.length < len) {
            str += r
            if (i < reasons.length - 1) {
              str += ', '
            }
          }
        })
        if (str.length >= len) {
          return str.substring(0, len) + '...'
        }
        return str
      },
      removeAllFlux () {
        let pkTab = []
        this.items.forEach(e => {
          this.deleteItem(e.pk)
          pkTab.push(e.pk)
        })
      },
      confirmDelete () {
        // Fake promise to emulate sweetAlter promise Behavior
        return new Promise(function (resolve, reject) {
          resolve({value: true})
        })
      },
      afterSuccessGet (r) {
      },
      afterSuccessDelete (eventId, r) {
        // this.$store.commit('removeEvent', {eventPk: eventId})
      },
      afterErrorDelete (err) {
        console.log(err)
      },
      deleteFlux (flux) {
        flux.forEach(x => {
          this.deleteItem(x.pk)
        })
      }
    },
    created () {
      this.loadItems()
    }
  }
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/flux/FluxList.vue